import React from 'react';
import PropTypes from 'prop-types';
import { ReadMoreToggle } from './styled';

const Consents = ({
  truthConsent,
  setTruthConsent,
  infoShareConsent,
  setInfoShareConsent,
  processConsent,
  setProcessConsent
}) => {
  return (
    <>
      <ReadMoreToggle
        name="truthConsent"
        onChange={() => setTruthConsent(!truthConsent)}
        isChecked={truthConsent}
        extraText="I/We confirm that I am/We are the
          claimant and/or the Policyholder and I/We declare that all the particulars given
          above are to the best of my/our knowledge true and correct."
      >
        I confirm the information given is the truth
      </ReadMoreToggle>
      <ReadMoreToggle
        name="infoShareConsent"
        onChange={() => setInfoShareConsent(!infoShareConsent)}
        isChecked={infoShareConsent}
        extraText="I/We hereby consent to and authorize the medical practitioner, hospital or other
          person involved in the claimant’s care to discuss and disclose treatment details
          and discharge arrangements with and to SafetyWing Insurance I.I. or its
          authorized agent or representative. I/We agree that a copy of this consent shall
          have the validity of the original."
      >
        I authorize the medical providers involved in my treatment/care/etc. to share info
        with SafetyWing
      </ReadMoreToggle>
      <ReadMoreToggle
        name="consent"
        onChange={() => setProcessConsent(!processConsent)}
        isChecked={processConsent}
        extraText="In connection with my/our and/or the claimant’s claims, I/We give consent for SafetyWing Insurance I.I. (“SafetyWing”), its Affiliates and their respective representatives or agents to collect, use, store, transfer and/or disclose the information (including that provided by sources other than myself) concerning me/us and/or the claimant, to or with all such persons (including any representative or any third party service provider) for the purpose of enabling SafetyWing and their respective representatives or agents to provide me/us and/or the claimant (where applicable) with services required of an insurance provider, including the evaluating, processing, administering and/or managing my/our and/or the claimant’s claims."
      >
        I authorize SafetyWing to collect/use/store/transfer/disclose and process my claim
        info
      </ReadMoreToggle>
    </>
  );
};

Consents.propTypes = {
  truthConsent: PropTypes.bool.isRequired,
  setTruthConsent: PropTypes.func.isRequired,
  infoShareConsent: PropTypes.bool.isRequired,
  setInfoShareConsent: PropTypes.func.isRequired,
  processConsent: PropTypes.bool.isRequired,
  setProcessConsent: PropTypes.func.isRequired
};

export default Consents;
